import React from 'react'
import { NavButton } from "./button";
import "./nav.css"

import dofbot from "../../pages/projects/individual-projects/images/dofbot_with_blocks.png"
import guitar from "../../images/guitar.jpg"
import soup from "../../images/soup.png"

const Nav = () => {
    return <div id="nav">
        <NavButton link="projects" label="projects" image={dofbot} fromHome={true}/>
        <NavButton link="about" label="about" image={guitar} fromHome={true} />
        <NavButton link="miscellaneous" label="misc." image={soup} />
    </div>;
}

export default Nav;